"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query venues($query: VenueQueryInput, $pagination: PaginationInput) {
    venues(query: $query, pagination: $pagination) {
      _id
      orgId
      name
      description
      capacity
      address {
        address1
        address2
        city
        state
        zip
        country
        phone
        lat
        lng
        placeId
        placeName
        timezone
      }
      url
      tax
      imageUrls
      venueGlobalId
    }
  }
`;
exports.default = query;
//# sourceMappingURL=venues.query.js.map